/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HouseCellarTypeEnum = 1 | 2 | 3;

export const HouseCellarTypeEnum = {
    NUMBER_1: 1 as HouseCellarTypeEnum,
    NUMBER_2: 2 as HouseCellarTypeEnum,
    NUMBER_3: 3 as HouseCellarTypeEnum
};

